import { recordEventCustomOnly } from 'utilities/uTagging';

export const doTagIsValidAndGoNext = () => {
    recordEventCustomOnly({
        event_name: 'event_success',
        eventCategory: 'onboarding/step2/readAndAcceptTheDocuments',
        eventAction: 'success',
        eventLabel: 'backend',
        action: 'success',
        format: 'steps',
        component: 'funnel',
        element: 'readAndAcceptTheDocuments',
    });
};
